var audio_rtlignore_default = {
  "fontElementMap": "hqtJT",
  "container": "e51Vz",
  "customPlayer": "_03ULW",
  "slim": "_6fV0q",
  "playPauseButton": "_4Nj35",
  "coverImage": "LOut0",
  "trackDetailsContainer": "-atHe",
  "controlsContainer": "Tr-CC",
  "controlsGroup": "_1eiKB",
  "sliderContainer": "_0aHAr",
  "audioDuration": "K0TCy",
  "isLoading": "_00iAf",
  "audioDetails": "bMzrb",
  "authorName": "yX2cF",
  "title": "nS0HJ",
  "dropdownMenuWrapper": "htu8O",
  "dropdownSelectedButton": "_0SeTH",
  "dropdownContent": "ho7HV",
  "dropdownContentWithIcon": "yVnKM",
  "audioLoader": "jiUYE"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
